import { Button as UiButton } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import { buttonVariants, type ButtonVariants } from '../../configs/button.config'

import type { ComponentProps } from 'react'

export function Button({ className, variant, size, ...props }: ComponentProps<typeof UiButton> & ButtonVariants) {
  return <UiButton className={cn(buttonVariants({ variant, size }), className)} {...props} />
}
